const PROPERTY_STRATEGIES_NAME = {
    PATRIMONIAL: 'Patrimonial',
    CAPITAL_GAIN_POOL: 'Pool de Plusvalía',
    BOOMERANG: 'Búmeran'
};
export default PROPERTY_STRATEGIES_NAME;
